module.exports = __webpack_public_path__ + "static/media/brycen4.92fde774.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brycen4.gif
// module id = 149
// module chunks = 0